export const REGULAR_DETALIZATION_REPORT_ACTIONS = {
  // ACTIONS FETCH
  FETCH_REGULAR_DETALIZATION_REPORT_DATA: 'REGULAR_DETALIZATION_REPORT:FETCH_REGULAR_DETALIZATION_REPORT_DATA',
  FETCH_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS: 'REGULAR_DETALIZATION_REPORT:FETCH_PERSONAL_DATA_SUCCESS',
  FETCH_REGULAR_DETALIZATION_REPORT_DATA_ERROR: 'REGULAR_DETALIZATION_REPORT:FETCH_REGULAR_DETALIZATION_REPORT_DATA_ERROR',
  // ACTIONS SAVE
  SAVE_REGULAR_DETALIZATION_REPORT_DATA: 'REGULAR_DETALIZATION_REPORT:SAVE_REGULAR_DETALIZATION_REPORT_DATA',
  SAVE_REGULAR_DETALIZATION_REPORT_DATA_SUCCESS: 'REGULAR_DETALIZATION_REPORT:SAVE_PERSONAL_DATA_SUCCESS',
  SAVE_REGULAR_DETALIZATION_REPORT_DATA_ERROR: 'REGULAR_DETALIZATION_REPORT:SAVE_REGULAR_DETALIZATION_REPORT_DATA_ERROR',
  SET_SAVE_REGULAR_DETALIZATION_REPORT_INITIAL_CONTROLS_DATA: 'REGULAR_DETALIZATION_REPORT:SET_SAVE_REGULAR_DETALIZATION_REPORT_INITIAL_CONTROLS_DATA',
};
